// extracted by mini-css-extract-plugin
export default {"container":"dW-z","title":"eW-z","link":"fW-z"};